// extracted by mini-css-extract-plugin
module.exports = {"printTable":"PrintTable_printTable__IyRwO"};